/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single filter option (API key or user)
 */
export type FilterOption = {
  /**
   * Number of events for this option
   */
  count: number;
  /**
   * Unique identifier for the option
   */
  id: string;
  /**
   * Display label for the option
   */
  label: string;
};

/** @internal */
export const FilterOption$inboundSchema: z.ZodMiniType<FilterOption, unknown> =
  z.object({
    count: z.int(),
    id: z.string(),
    label: z.string(),
  });

export function filterOptionFromJSON(
  jsonString: string,
): SafeParseResult<FilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FilterOption' from JSON`,
  );
}
